import { CanActivateFn, RedirectCommand, Router } from "@angular/router";
import { inject } from "@angular/core";
import { SpatialAnalysisService } from "../../modules/spatial-analysis/spatial-analysis.service";

export const canLoadSpatialAnalysisGuard: CanActivateFn = () => {
  const router = inject(Router);
  const spatialAnalysisData = inject(SpatialAnalysisService).spatialAnalysisData();
  if (!spatialAnalysisData) {
    return new RedirectCommand(router.parseUrl("/"));
  }

  return true;
};
